import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NgModel } from '@angular/forms';
// import {NgIf, NgFor, NgClass} from "@angular/common";

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'ng-college-pagination[ngModel]',
    //  directives: [NgIf, NgFor, NgClass],
    template: `
                  <div class="ns-list-interactions" *ngIf="(maxSize < totalItems)">
                  <div class="ns-list-interactions-sorting" *ngIf="includeSort">
                    <label class="ns-list-interactions-sorting-label" for="ns-sorting-select">Sort By:</label>
                    <select class="ns-list-interactions-sorting-select ns-input-small" id="ns-sorting-select">
                      <option selected disabled>Select an option ...</option>
                      <option>Option 1</option>
                      <option>Option 2</option>
                      <option>Option 3</option>
                    </select>
                    <span class="ns-list-interactions-sorting-as-tile">Q</span>
                    <span class="ns-list-interactions-sorting-as-list">"</span>
                  </div>
                  <div class="ns-list-interactions-pagination">
                    <ol class="ns-list-interactions-pagination-list">
                      <li class="ns-list-interactions-pagination-list-button-previous"><button class="ns-button direction-btn ns-button-small ns-button-white"
                      *ngIf="arrowButtons || previousItemValid" [disabled]="!previousItemValid" (click)="previousPage(nextItem)" aria-label="Previous"> 
                        <ng-container *ngIf="!arrowButtons; else arrow">Previous</ng-container>
                      </button></li>
                      <ng-container *ngFor="let pageNo of pageList">
                      <li class="ns-list-interactions-pagination-list-button-generic" *ngIf="pageNo < nextSize" [ngClass]="{'ns-list-interactions-pagination-list-button-current':seletedPage === pageNo}">
                      <button *ngIf="seletedPage === pageNo" class="ns-button ns-button-small ns-button-magenta">{{pageNo}}</button>
                      <span style="cursor: pointer;" *ngIf="seletedPage !== pageNo" (click)="setCurrentPage(pageNo)">{{pageNo}}  </span>
                      </li>
                      </ng-container>

                      <ng-container>
                      <li class="ns-list-interactions-pagination-list-button-next">
                      <span style="cursor: pointer;">...</span>
                     
                      </li>
                      <li class="ns-list-interactions-pagination-list-button-next">
                      <span style="cursor: pointer;"> {{ totalSize }}   </span>
                     
                      </li>
                      </ng-container>

                      <li class="ns-list-interactions-pagination-list-button-next"><button class="ns-button direction-btn ns-button-small ns-button-white"
                      *ngIf="arrowButtons || nextItemValid" [disabled]="!nextItemValid" (click)="nextPage(nextItem)" aria-label="Next">
                        <ng-container *ngIf="!arrowButtons; else arrow">Next</ng-container>
                      </button></li>

                    </ol>
                   
                  </div>
                </div>
    <ng-template #arrow>
      <img src="/assets/img/arrow-right-fill.png" width="15" alt="">
    </ng-template>
`,
    styleUrls: ['./pagination-directive.directive.scss']
})
// tslint:disable-next-line:component-class-suffix
export class CollegePaginationDirective implements ControlValueAccessor, OnInit, OnChanges {
    // tslint:disable-next-line:no-input-rename
    @Input('previous-text') previousText: string;
    // tslint:disable-next-line:no-input-rename
    @Input('next-text') nextText: string;
    // tslint:disable-next-line:no-input-rename
    @Input('first-text') firstText: string;
    // tslint:disable-next-line:no-input-rename
    @Input('last-text') lastText: string;
    @Input() arrowButtons = false;
    @Input() totalItems: number;
    @Input() currentPage: number;
    @Input() maxSize: number;
    @Input() boundaryLinks: boolean;
    @Input() includeSort: boolean;
    @Output('pageChanged') pageChanged = new EventEmitter();
    currentpage: number;
    pageList: Array<number> = [];
    onChange: Function;
    onTouched: Function;
    seletedPage: number;
    nextItem: number;
    previousItem: number;
    nextItemValid: boolean;
    previousItemValid: boolean;
    totalSize: number;
    nextSize = 4;

    constructor(public pageChangedNgModel: NgModel) {
        this.pageChangedNgModel.valueAccessor = this;

    }
    ngOnInit() {
        this.doPaging();
    }
    ngOnChanges() {
        this.nextSize = 4;
        this.doPaging();
    }
    doPaging() {
        this.pageList = [];
        let i: number, count: number;
        this.seletedPage = this.currentpage;
        const remaining = this.totalItems % this.maxSize;
        this.totalSize = ((this.totalItems - remaining) / this.maxSize) + (remaining === 0 ? 0 : 1);
        for (i = (this.currentpage), count = 0; i <= this.totalSize && count < this.maxSize; i++ , count++) {
            this.pageList.push(i);
        }
        // next validation
        if (this.currentpage - 1 < this.totalSize && (this.currentpage !== this.totalSize)) {
            this.nextItemValid = true;
            this.nextItem = this.seletedPage + 1;
        } else {
            this.nextItemValid = false;
        }
        // previous validation
        if ((this.currentpage) > 1) {
            this.previousItemValid = true;
            this.previousItem = (this.currentpage) - 1;
        } else {
            this.previousItemValid = false;
        }
    }
    setCurrentPage(pageNo: number) {
        this.currentpage = pageNo;
        this.nextSize = pageNo + 3;
        this.pageChangedNgModel.viewToModelUpdate(pageNo);
        this.pageChageListner();
        this.doPaging();
    }
    firstPage() {
        this.currentpage = 1;
        this.pageChangedNgModel.viewToModelUpdate(1);
        this.pageChageListner();
        this.doPaging()
    }
    lastPage() {
        const totalPages = (this.totalItems / this.maxSize);
        const lastPage = (totalPages) - (totalPages % this.maxSize === 0 ? this.maxSize : totalPages % this.maxSize) + 1;
        this.currentpage = lastPage;
        this.pageChangedNgModel.viewToModelUpdate(lastPage);
        this.pageChageListner();
        this.doPaging()
    }
    nextPage(pageNo: number) {
        this.nextSize = this.nextSize + 1;
        this.currentpage = pageNo;
        this.pageChangedNgModel.viewToModelUpdate(pageNo);
        this.pageChageListner();
        this.doPaging()
    }
    previousPage(pageNo: number) {
        this.nextSize = this.nextSize - 1;
        // let temp = pageNo - 1 - this.maxSize;
        // let temp = (pageNo - this.maxSize) - this.maxSize;
        this.currentpage = pageNo > 1 ? this.currentpage - 1 : 1;
        this.pageChangedNgModel.viewToModelUpdate(this.currentpage);
        this.pageChageListner();
        this.doPaging();

    }
    writeValue(value: string): void {
        if (!value && value !== '0') { return; }
        this.setValue(value);
    }

    registerOnChange(fn: (_: any) => {}): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: (_: any) => {}): void {
        this.onTouched = fn;
    }
    setValue(currentValue: any) {
        this.currentpage = currentValue;
        this.doPaging();
    }
    pageChageListner() {
        this.pageChanged.emit({
            itemsPerPage: this.currentpage
        })
    }
}
